var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "wl-container" }, [
    _c("div", { staticClass: "wl-img-list" }, [
      _c(
        "ul",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "wl-clear-float",
          style: {
            backgroundColor: _vm.pagination.total >= 1 ? "" : "#ffffff",
          },
        },
        [
          _vm._l(_vm.data, function (item, index) {
            return _c(
              "li",
              { key: item.id, class: (index + 1) % 4 === 0 ? "noMarginR" : "" },
              [
                _c(
                  "a",
                  {
                    attrs: { href: item.insightUrl },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.navTo(item.insightUrl)
                      },
                    },
                  },
                  [
                    item.imageByte
                      ? _c("div", {
                          staticClass: "imageItem",
                          style: `background-image: url( data:image/png;base64,${item.imageByte});
                background-size: auto 100%;
                background-repeat: no-repeat;
                background-position: center;
             `,
                        })
                      : _c("div", { staticClass: "imageItem bg-img" }),
                  ]
                ),
                _c(
                  "span",
                  {
                    staticClass: "show-overflow-tooltip insightTitle",
                    attrs: { title: item.insightTitle },
                  },
                  [_vm._v(_vm._s(item.insightTitle) + " ")]
                ),
              ]
            )
          }),
          _vm.pagination.total <= 0
            ? _c(
                "div",
                {
                  staticClass: "el-table__empty-block",
                  staticStyle: { height: "300px" },
                },
                [
                  _c("p", { staticClass: "el-table__empty-text" }, [
                    _vm._v(_vm._s(_vm.$t("INSIGHTS_NO_DATA"))),
                  ]),
                ]
              )
            : _vm._e(),
          _c("el-pagination", {
            staticClass: "wl-pagination",
            attrs: {
              "current-page": _vm.pagination.current,
              "page-size": _vm.pagination.pageSize,
              layout: "prev, pager, next,total",
              total: _vm.pagination.total,
            },
            on: { "current-change": _vm.onCurrentPageChange },
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }